import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useFormInputs, useFeathers } from '../../app/util';
import { SearchableSelectInput } from '../SearchableSelectInput';

const ElectionSelectInput = ({
  value,
  onChange,
  name='election',
  style = {},
  disabled = false,
  className,
  district = null,
  query = {}
}) => {
  const feathers = useFeathers();

  const [ optionsForField, setOptionsForField ] = useState([]);
  const [ loadingForField, setLoadingForField ] = useState(false);
  const searchForField = async (searchText) => {
    if(!feathers) return;
    setLoadingForField(true);

    const electionQuery = {
      ...(searchText ? { $search: searchText } : {}),
      ...query,
      $sort: { date: -1 }
    };

    // Filter by district if provided
    if (district) {
      electionQuery.districts = [ district ];
    }

    const elections = await feathers.getService('elections').find({ query: electionQuery });
    const options = elections.data.map(({ name, key, date }) => ({ 
      text: name, 
      key, 
      name,
      subText: date ? new Date(date).toLocaleDateString() : undefined
    }));

    setOptionsForField(options)
    setLoadingForField(false);
  }

  return (
    <SearchableSelectInput
      name={name}
      onChangeSearchText={(searchText) => searchForField(searchText)}
      value={value}
      onChange={onChange}
      optionsLoading={loadingForField}
      options={optionsForField || []}
      style={{
        backgroundColor: '#FFFFFF',
        ...(style || {})
      }}
      disabled={disabled}
      className={className}
      placeholder={'Election name'}
    />
  )
}

export { ElectionSelectInput };
